/** Inline stroke icons for the three Home entry cards (IA slice 1) — copied
 * from the founder-approved mock (design-ia/Main.dc.html) as React
 * components, same rationale as `app/navIcons.tsx` (no
 * `dangerouslySetInnerHTML`, inherits `currentColor`). Sized 24x24 to match
 * the mock's entry-card icons (larger than the 18x18 nav icons). */
import type { SVGProps } from "react";
import { DevelopIcon } from "../../app/navIcons";

function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    />
  );
}

/** "Develop it" reuses the nav's own Develop glyph at entry-card size — same
 * concept (co-author the app), one icon, not a second drawing of it. */
export function DevelopEntryIcon(props: SVGProps<SVGSVGElement>) {
  return <DevelopIcon {...props} width="24" height="24" />;
}

export function AdoptEntryIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M12 3v12" />
      <path d="m7 10 5 5 5-5" />
      <path d="M4 21h16" />
    </Icon>
  );
}

export function ScaffoldEntryIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <rect x="3" y="3" width="8" height="8" rx="1.5" />
      <rect x="13" y="3" width="8" height="8" rx="1.5" />
      <rect x="3" y="13" width="8" height="8" rx="1.5" />
      <path d="M17 14v6M14 17h6" />
    </Icon>
  );
}
